var _circle, _path, _g, _path2, _path3, _path4, _g2, _path5, _path6, _g3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStructureAtRoads(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 39,
    viewBox: "0 0 39 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 19.4597,
    cy: 19.5,
    r: 18.7112,
    stroke: "#64E7A5",
    strokeWidth: 1.4969
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1402_1625)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1402_1625",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 7,
    y: 7,
    width: 24,
    height: 24
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.81665 7.72925H30.8166V30.7292H7.81665V7.72925Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1402_1625)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.9831 30.0535H10.6526V8.40494H27.9831V30.0535Z",
    stroke: "#64E7A5",
    strokeWidth: 1.34766,
    strokeMiterlimit: 10
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3177 17.5702V20.8887",
    stroke: "#64E7A5",
    strokeWidth: 1.34766,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3177 22.6137V25.9321",
    stroke: "#64E7A5",
    strokeWidth: 1.34766,
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_1402_1625",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 7,
    y: 7,
    width: 24,
    height: 24
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.81665 7.72925H30.8166V30.7292H7.81665V7.72925Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_1402_1625)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.3177 27.657V30.0535",
    stroke: "#64E7A5",
    strokeWidth: 1.34766,
    strokeMiterlimit: 10
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3177 12.5265V15.845",
    stroke: "#64E7A5",
    strokeWidth: 1.34766,
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_1402_1625",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 7,
    y: 7,
    width: 24,
    height: 24
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M7.81665 7.72925H30.8166V30.7292H7.81665V7.72925Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_1402_1625)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.3177 8.40507V10.8015",
    stroke: "#64E7A5",
    strokeWidth: 1.34766,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.2876 8.40494V30.0535",
    stroke: "#64E7A5",
    strokeWidth: 1.34766,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3481 8.40494V30.0535",
    stroke: "#64E7A5",
    strokeWidth: 1.34766,
    strokeMiterlimit: 10
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1402_1625"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23,
    height: 23,
    fill: "white",
    transform: "translate(7.81665 7.72925)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStructureAtRoads);
export default __webpack_public_path__ + "static/media/StructureAtRoads.a2c6f9b1a6d997bed9f98a891077f15b.svg";
export { ForwardRef as ReactComponent };